import { render, staticRenderFns } from "./DodPanelSettings.vue?vue&type=template&id=e18dfbee&scoped=true&"
import script from "./DodPanelSettings.vue?vue&type=script&lang=js&"
export * from "./DodPanelSettings.vue?vue&type=script&lang=js&"
import style0 from "./DodPanelSettings.vue?vue&type=style&index=0&id=e18dfbee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18dfbee",
  null
  
)

export default component.exports